import { AlertCircle, AlertTriangle, CheckCircle2, Info, X } from 'lucide-react';

/**
 * Banner minimal del addendum: rules horizontales, sin background tintado,
 * sin radius. Icon coloreado por tone + texto en text-small text-ink-muted.
 *
 * Para estado clínico (criterio de escalamiento, evento clínico activo) no
 * usar Banner — usar <DxClause> o <DiagnosticArticle>.
 *
 * @param {Object} props
 * @param {'error'|'warning'|'success'|'info'} [props.tone='info']
 * @param {React.ReactNode} [props.icon]    Override del icono default por tone.
 * @param {React.ReactNode} [props.action]  Acción a la derecha
 *                                           (típicamente un <Button ghost sm>).
 * @param {() => void} [props.onDismiss]    Si presente muestra botón close.
 * @param {React.ReactNode} props.children   Mensaje del banner.
 */
export default function Banner({ tone = 'info', icon, action, onDismiss, children }) {
  const cfg = TONE_CONFIG[tone] || TONE_CONFIG.info;
  const IconComponent = cfg.Icon;
  const role = tone === 'error' ? 'alert' : 'status';

  return (
    <div
      role={role}
      className="flex items-center gap-3 border-t border-b border-edge bg-transparent py-3 px-4"
    >
      <span className={`${cfg.colorClass} flex-shrink-0`} aria-hidden="true">
        {icon || <IconComponent size={14} strokeWidth={1.6} />}
      </span>
      <span className="flex-1 min-w-0 text-small text-ink-muted font-sans">
        {children}
      </span>
      {action && <span className="flex-shrink-0">{action}</span>}
      {onDismiss && (
        <button
          type="button"
          onClick={onDismiss}
          aria-label="Cerrar"
          className="flex-shrink-0 text-ink-muted hover:text-ink transition-colors p-1"
        >
          <X size={14} strokeWidth={1.6} />
        </button>
      )}
    </div>
  );
}

const TONE_CONFIG = {
  error:   { Icon: AlertCircle,   colorClass: 'text-system-error' },
  warning: { Icon: AlertTriangle, colorClass: 'text-system-warning' },
  success: { Icon: CheckCircle2,  colorClass: 'text-system-success' },
  info:    { Icon: Info,          colorClass: 'text-system-info' },
};
